import Route from '@ember/routing/route';

export default class ImportLogsRoute extends Route {}
